<h4 mat-dialog-title>
    <mat-toolbar role="toolbar" [ngClass]="dialog_class">
        <span class="modal-btn-close" class="modal-header-title" style="font-size: 15px;">{{header_title}}</span>
        <span class="fx-spacer"></span>
        <!-- <button mat-icon-button (click)="close()" [disabled]="api_call">
            <mat-icon mat-list-icon class="modal-btn-close" >close</mat-icon>
        </button> -->
    </mat-toolbar>
</h4>

<div mat-dialog-content class="cfm-modal-message">

    <p [class.hide]="api_call" style="text-align: justify; font-size: 14px; overflow-y: scroll;" [innerHTML]="dialog_message"></p>

    <div class="process-spinner delete-spinner-color" [class.hide]="!api_call"> 
        <mat-spinner class="mat-dialog-spinner" [diameter]="50" [ngClass]="spinner_class"></mat-spinner>  
        <p>{{api_call_mesage}}</p>
    </div>
  
</div>
<div mat-dialog-actions style="padding-left: 75%;">
    <button 
    mat-button
        color="primary" (click)="close()" 
        [disabled]="api_call">
        {{close_cancel}}</button>
 
    
</div>
